// extracted by mini-css-extract-plugin
export default {"downloadIcon":"DownloadButton__downloadIcon--_Mqg2","downloadReleaseLink":"DownloadButton__downloadReleaseLink--VzsmC"};